/**
 * 'App.store'
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */

import http from '@/services/http.service'

export default {
  namespaced: true,
  state: {
    order: {
      clientName: null,
      clientEmail: null,
      clientPhone: null,
      carBrand: null,
      carModel: null,
      invoicePath: null,
      codes: [],
      tyres: 1
    },
    brandId: null,
    profile: {
      name: ''
    },
    step: 1,
    hasData: false
  },
  getters: {
    order: state => {
      return state.order
    },
    brandId: state => {
      return state.brandId
    },
    profile: state => {
      return state.profile
    },
    step: state => {
      return state.step
    },
    hasData: state => {
      return state.hasData
    }
  },
  mutations: {
    order (state, payload) {
      state.order = Object.assign(state.order, payload)
    },
    profile (state, payload) {
      state.profile = Object.assign({}, payload)
    },
    brandId (state, payload) {
      state.brandId = payload
      state.order.promotionId = null
    },
    step (state, payload) {
      state.step = payload
    },
    hasData (state) {
      state.hasData = true
    }
  },
  actions: {
    order ({commit}, payload) {
      commit('order', payload)
    },
    clearOrder ({commit}) {
      commit('order', {
        clientName: null,
        clientEmail: null,
        clientPhone: null,
        carBrand: null,
        carModel: null,
        invoicePath: null,
        codes: [],
        tyres: 1
      })
    },
    brandId ({commit}, payload) {
      commit('brandId', payload)
    },
    profile ({commit}, payload) {
      return http.get('auth/profile').then(response => {
        commit('profile', response.data)
      })
    },
    step ({commit}, payload) {
      commit('step', payload)
    },
    hasData ({commit}) {
      commit('hasData')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/app.store.js